(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    root.classList.add('is-enhanced');
    const mediaItems = [...root.querySelectorAll('[data-product-media]')];
    const thumbnails = [...root.querySelectorAll('[data-media-select]')];
    const selectMedia = (id) => {
      if (!mediaItems.some((media) => media.dataset.productMedia === id)) return;
      mediaItems.forEach((media) => {
        const active = media.dataset.productMedia === id;
        media.hidden = !active;
        if (!active) media.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbnails.forEach((thumbnail) => {
        if (thumbnail.dataset.mediaSelect === id) thumbnail.setAttribute('aria-current', 'true');
        else thumbnail.removeAttribute('aria-current');
      });
    };
    const initialMedia = root.querySelector('[data-selected-media]') || mediaItems[0];
    if (initialMedia) selectMedia(initialMedia.dataset.productMedia);
    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', (event) => {
        event.preventDefault();
        selectMedia(thumbnail.dataset.mediaSelect);
      });
      thumbnail.addEventListener('keydown', (event) => {
        if (!['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const currentIndex = thumbnails.indexOf(thumbnail);
        let nextIndex = event.key === 'ArrowRight' ? currentIndex + 1 : currentIndex - 1;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = thumbnails.length - 1;
        const next = thumbnails[(nextIndex + thumbnails.length) % thumbnails.length];
        next.focus();
        selectMedia(next.dataset.mediaSelect);
      });
    });
    const quantity = root.querySelector('[data-quantity-input]');
    const quantityButtons = [...root.querySelectorAll('[data-quantity-change]')];
    const updateQuantityButtons = () => {
      const value = Number(quantity.value);
      const minimum = Number(quantity.min) || 1;
      const maximum = quantity.max ? Number(quantity.max) : Infinity;
      quantityButtons.forEach((button) => {
        button.disabled = Number(button.dataset.quantityChange) < 0 ? value <= minimum : value >= maximum;
      });
    };
    if (quantity) {
      quantityButtons.forEach((button) => {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (Number(button.dataset.quantityChange) < 0) quantity.stepDown();
          else quantity.stepUp();
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      quantity.addEventListener('input', updateQuantityButtons);
      quantity.addEventListener('change', updateQuantityButtons);
      updateQuantityButtons();
    }
    const variantSelect = root.querySelector('[data-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', () => {
        const variant = variantSelect.selectedOptions[0];
        const available = variant.dataset.available === 'true';
        root.querySelector('[data-product-price]').textContent = variant.dataset.price;
        const compare = root.querySelector('[data-product-compare]');
        compare.textContent = variant.dataset.compare;
        compare.hidden = !variant.dataset.compare;
        root.querySelector('[data-product-sale]').hidden = !variant.dataset.compare;
        root.querySelector('[data-product-submit]').disabled = !available;
        root.querySelector('[data-product-submit-label]').textContent = available ? root.dataset.availableLabel : root.dataset.unavailableLabel;
        const stickyPrice = root.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = variant.dataset.price;
        if (quantity) {
          quantity.min = variant.dataset.quantityMin || '1';
          quantity.step = variant.dataset.quantityStep || '1';
          if (variant.dataset.quantityMax) quantity.max = variant.dataset.quantityMax;
          else quantity.removeAttribute('max');
          quantity.value = quantity.min;
          updateQuantityButtons();
        }
        if (variant.dataset.mediaId) selectMedia(variant.dataset.mediaId);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.value);
        window.history.replaceState({}, '', url);
      });
    }
    const sticky = root.querySelector('[data-product-sticky]');
    const form = root.querySelector('.indigo-product__form');
    if (sticky && form && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
      }, { threshold: 0 });
      observer.observe(form);
      const disconnect = (event) => {
        if (!event.target.contains(root)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', disconnect);
      };
      document.addEventListener('shopify:section:unload', disconnect);
      root.querySelector('[data-product-scroll]').addEventListener('click', (event) => {
        event.preventDefault();
        form.scrollIntoView({ block: 'center', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        const target = variantSelect || quantity || root.querySelector('[data-product-submit]');
        if (target) target.focus({ preventScroll: true });
      });
    }
  };
  document.querySelectorAll('[data-indigo-product]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-indigo-product]').forEach(initialize);
  });
})();
